export const API = {
  BRIEF: {
    PUBLIC: "/rfp/draft/:shareId",
    EDIT: "/rfp/enquiry/edit/:shareId",
  },
  PROPOSAL: {
    INVITE: "/rfp/proposal/share/:id",
  },
  REASSIGN_COMPANY: "/rfp/enquiry/:id/reassign-company",
};

export const FRONTEND = {
  RFP: {
    CHECKSHEET: "/admin/rfp/checksheet",
    INITIAL_RESPONSE: "/admin/rfp/initial-response",
    VENUES: {
      MY_RFPS: "/admin/your-rfps",
      VIEW_CONFIRMATION: "/admin/your-rfps/:id/confirm/:enquiryVenueDataId",
      VIEW_ENQUIRY: "/admin/your-rfps/:id?",
    },
    ADMIN: {
      VIEW_CONFIRMATION: "/admin/rfp/:id/confirm/:enquiryVenueDataId",
      VIEW_ENQUIRY: "/admin/rfp/:id?",
    }
  }
}
